import { Color } from "./Expr"

export type LDInstanceMeta = {
  strokeColor: Color
  fillColor: Color
  strokeWidth: number
  markerRadius: number
  eraserRadius: number
  showGrid: boolean
  showLayers: boolean
  onlySelectedLayer: boolean
}

export namespace LDInstanceMeta {
  export const defaultMeta: LDInstanceMeta = {
    strokeColor: "black" as Color,
    fillColor: "blue" as Color,
    strokeWidth: 5,
    markerRadius: 20,
    eraserRadius: 10,
    showGrid: false,
    showLayers: false,
    onlySelectedLayer: false,
  }
}
